<div class="change-password">
  <mat-toolbar>
    <h2>Change Password</h2>
  </mat-toolbar>
  <form [formGroup]="changePasswordForm" (ngSubmit)="changePasswordClickHandler()" novalidate>
    <mat-dialog-content>
      <div class="text-center mb-8">
        <mat-form-field>
          <mat-label>Current Password</mat-label>
          <input matInput type="password" formControlName="currentPassword" required />
          @if (changePasswordForm.get('currentPassword')?.hasError('required')) {
            <mat-error>Current Password is required</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="text-center mb-8">
        <mat-form-field>
          <mat-label>New Password</mat-label>
          <input matInput type="password" formControlName="newPassword" required />
          @if (changePasswordForm.get('newPassword')?.hasError('required')) {
            <mat-error>New Password is required</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="text-center">
        <mat-form-field>
          <mat-label>Confirm Password</mat-label>
          <input matInput type="password" formControlName="confirmPassword" required />
          @if (changePasswordForm.get('confirmPassword')?.hasError('required')) {
            <mat-error>Confirm Password is required</mat-error>
          }
          @if (
            !changePasswordForm.get('confirmPassword')?.hasError('required') &&
            changePasswordForm.get('newPassword')?.value !==
              changePasswordForm.get('confirmPassword')?.value
          ) {
            <mat-error>Passwords do not match</mat-error>
          }
        </mat-form-field>
      </div>
    </mat-dialog-content>

    <div mat-dialog-actions class="flex justify-end mt-8">
      <button
        mat-flat-button
        type="button"
        (click)="closeDialogClickHandler()"
        [disabled]="isChangingPassword()"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="accent"
        type="submit"
        [disabled]="
          isChangingPassword() ||
          !changePasswordForm.valid ||
          changePasswordForm.get('newPassword')?.value !==
            changePasswordForm.get('confirmPassword')?.value
        "
      >
        Change Password
      </button>
    </div>
  </form>
</div>
